// Filename: views/layout/supervisor.js
define('views/app/supervisor/setting',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // Templates
    'text!templates/app/supervisor/setting.html'
], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // Templates
    TLayoutSettingPage
) {

    var VLayoutSettingPage = Backbone.View.extend({

        template: TLayoutSettingPage,

        initialize: function() {
        },

        render: function() {
            // Render Template HTML with Mustache
            this.$el.html(Mustache.to_html(this.template));
        },

    });

    return VLayoutSettingPage;

});

